<template>
    <nav class="navbar navbar-expand-lg navbar-light bg-light" :class="{'navbarOpen': show}">
        <router-link class="navbar-brand" to="/admin">Olivia Admin Panel</router-link>
        <button class="navbar-toggler"
                type="button"
                data-toggle="collapse"
                data-target="#navbarSupportedContent"
                aria-controls="navbarSupportedContent"
                aria-expanded="false"
                aria-label="Toggle navigation"
                @click.stop="toggleNavigation"
        >
            <span class="navbar-toggler-icon"/>
        </button>

        <div class="collapse navbar-collapse" id="navbarSupportedContent" :class="{ 'show': show }">
            <ul class="navbar-nav mr-auto">
                <li class="nav-item" :class="{active: $route.name === 'adminOrders'}">
                    <router-link class="nav-link" to="/admin">Porudzbine</router-link>
                </li>
                <li class="nav-item" :class="{active: $route.name === 'adminItems'}">
                    <router-link class="nav-link" to="/admin/items">Proizvodi</router-link>
                </li>
                <li class="nav-item" :class="{active: $route.name === 'adminBlog'}">
                    <router-link class="nav-link" to="/admin/blog">Blog</router-link>
                </li>
                <li class="nav-item">
                    <router-link class="nav-link" to="/admin/login">Odjavi se</router-link>
                </li>
            </ul>
        </div>
    </nav>
</template>

<script>
export default {
    name: 'AdminNavigation',
    data() {
        return {
            show: false
        }
    },
    methods: {
        toggleNavigation() {
            this.show = !this.show
        }
    }
}
</script>

<style scoped>

</style>